/**
 * @owner @Appboy/operator
 */

import { useEffect, useRef } from "react";

import { getPusherSingleton } from "./pusherSingleton";
import type { UsePusherStateOptions } from "./types";

/**
 * Subscribes to dashboard Pusher connection `state_change` and runs `onReconnect` when `states.current` is
 * `connected`.
 */
export const usePusherState = (options: UsePusherStateOptions): void => {
  const onReconnectRef = useRef(options.onReconnect);
  onReconnectRef.current = options.onReconnect;

  useEffect(() => {
    const connection = getPusherSingleton().pusher.connection;

    const onStateChange = (states: { previous: string; current: string }) => {
      if (states.current === "connected") {
        onReconnectRef.current?.();
      }
    };

    connection.bind("state_change", onStateChange);

    return () => {
      connection.unbind("state_change", onStateChange);
    };
  }, []);
};
